import { getDataMapFromCommonResponse } from 'src/mentor/helpers/utilityFunctions'

export function prepareBookedEventsDataFromApiResponse(response) {
  const data = getDataMapFromCommonResponse(response)
  const bookedEvents = data?.['booked-event-info']?.content
  const patientInfos = data?.['PatientInfo']
  const clinicBrandData = data?.['clinic-brand']
  const clinicLocationData = data?.['clinic']
  return bookedEvents.map((event) => ({
    ...event,
    clinicBrandData: clinicBrandData.find((brand) => brand.id === event.clinicBrandId),
    clinicLocation: clinicLocationData.find((location) => location.id === event.clinicId),
    patientInfo: patientInfos.find((patient) => patient.id === event.patientId),
  }))
}
